import { Component } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    public translateService: TranslateService,
  ) {
    this.translateService.addLangs(['en', 'zh'])
    this.translateService.setDefaultLang('en')

    const browserLang = this.translateService.getBrowserLang()
    this.translateService.use(browserLang && browserLang.match(/en|zh/) ? browserLang : 'en')
  }
}
